/* eslint-disable import/no-duplicates */
import { differenceInCalendarDays, format } from 'date-fns';
import { ru } from 'date-fns/locale';

export const formatShortDate = (dateMs: number): string => {
  const daysNumber = differenceInCalendarDays(new Date(), new Date(dateMs));

  if (daysNumber === 1) {
    return 'Вчера';
  }

  if (daysNumber > 1) {
    return format(new Date(dateMs), 'd MMM', { locale: ru });
  }

  return format(new Date(dateMs), 'HH:mm', { locale: ru });
};
